import React, { Fragment, useEffect, useState } from "react";
import {
  Col,
  Card,
  Table,
} from "react-bootstrap";
import RemarkModal from "./RemarkModal";
import { useParams } from "react-router-dom";
import NotCleardCard from "./NotCleardCard";
import CleardCard from "./CleardCard";
import {
  clearIndividualVerfication,
  getIndividualVerfiedByID,
} from "../../../services/adminApiService/individualApiService/IndividualAPiService";

import {
  formatLable
} from "../../../utils/colorAsperStatus";
import IndividualDetails from "./IndividualDetails";
import doc from "../../../images/google-docs.png";
import imgPdf from "../../../images/pdf.png";
import {
  getCountryFromId,
  getStateFromId,
} from "../../../utils/CountryConveter";
import { getCorrectionByID } from "../../../services/adminApiService/admincorrectionApi/adminCorrectionApi";

const IndividualVerificationForm = ({ roletype }) => {
  const { id } = useParams();
  const [remarkshowModal, setRemarkshowModal] = useState(false);
  const [showremarkrCard, setshowremarkCard] = useState(true);
  const [verficationList, setVerficationList] = useState({});
  const [insituteVerifyList, setInsituteVerifyList] = useState([]);
  const [correctionData, setCorrectionData] = useState([]);
  const [remarkdata, setRemarkdata] = useState("");
  const [currentRemarkId, setCurrentRemarkId] = useState(null);

  useEffect(() => {
    const fetchVerificationList = async () => {
      try {
        const response = await getIndividualVerfiedByID(id);
        setVerficationList(response?.data?.data);
      } catch (error) {
        console.error("Error fetching verification list:", error);
      }
    };

    fetchVerificationList();
  }, [id]);
  const isValidUrl = (string) => {
    try {
      new URL(string);
      return true;
    } catch (_) {
      return false;
    }
  };

  const fetchCountryName = async () => {
    const storedRemarks =
      JSON.parse(localStorage.getItem(`remarksIndividual`)) || {};

    if (Object.keys(verficationList).length > 0) {
      const countryName = await getCountryFromId(verficationList.country);
      const stateName = await getStateFromId(
        verficationList.country,
        verficationList.state
      );
    
      const baseList = [
        { id: 1, label: "First Name", key: "first_name", value: verficationList?.first_name, isError: !!storedRemarks[1], action: false, remark: storedRemarks[1] || "" },
        { id: 2, label: "Middle Name", key: "middle_name", value: verficationList?.middle_name, isError: !!storedRemarks[2], action: false, remark: storedRemarks[2] || "" }, // Added middle_name
        { id: 3, label: "Last Name", key: "last_name", value: verficationList?.last_name, isError: !!storedRemarks[3], action: false, remark: storedRemarks[3] || "" }, // Added last_name
        { id: 4, label: "Date of Birth", key: "dob", value: verficationList?.dob, isError: !!storedRemarks[4], action: false, remark: storedRemarks[4] || "" },
        { id: 5, label: "Age", key: "age", value: verficationList?.age, isError: !!storedRemarks[5], action: false, remark: storedRemarks[5] || "" },
        { id: 6, label: "Gender", key: "gender", value: verficationList?.gender, isError: !!storedRemarks[6], action: false, remark: storedRemarks[6] || "" },
        { id: 7, label: "Father Name", key: "father_name", value: verficationList?.father_name, isError: !!storedRemarks[7], action: false, remark: storedRemarks[7] || "" },
        { id: 8, label: "Address", key: "address", value: verficationList?.address, isError: !!storedRemarks[8], action: false, remark: storedRemarks[8] || "" },
        { id: 9, label: "Landmark", key: "landmark", value: verficationList?.landmark, isError: !!storedRemarks[9], action: false, remark: storedRemarks[9] || "" },
        { id: 10, label: "Country", key: "country", value: countryName, isError: !!storedRemarks[10], action: false, remark: storedRemarks[10] || "" },
        { id: 11, label: "State", key: "state", value: stateName, isError: !!storedRemarks[11], action: false, remark: storedRemarks[11] || "" },
        { id: 12, label: "District", key: "city", value: verficationList?.city_name, isError: !!storedRemarks[12], action: false, remark: storedRemarks[12] || "" },
        { id: 13, label: "Pincode", key: "pincode", value: verficationList?.pincode, isError: !!storedRemarks[13], action: false, remark: storedRemarks[13] || "" },
        { id: 14, label: "Sport Name", key: "sport_id", value: verficationList?.refsport?.sport_name, isError: !!storedRemarks[14], action: false, remark: storedRemarks[14] || "" },
        { id: 15, label: "Kit Size", key: "kit_size", value: verficationList?.kit_size_name, isError: !!storedRemarks[15], action: false, remark: storedRemarks[15] || "" },
        { id: 16, label: "Shoe Size", key: "shoe_size", value: verficationList?.shoe_size, isError: !!storedRemarks[16], action: false, remark: storedRemarks[16] || "" },
        { id: 17, label: "Organization Name", key: "orgnization_id", value: verficationList?.organization_name, isError: !!storedRemarks[17], action: false, remark: storedRemarks[17] || "" },
        { id: 18, label: "Athlete Level", key: "athlete_level", value: verficationList?.athlete_level, isError: !!storedRemarks[18], action: false, remark: storedRemarks[18] || "" },
        { id: 19, label: "Bank Name", key: "bank_name", value: verficationList?.bank_name, isError: !!storedRemarks[19], action: false, remark: storedRemarks[19] || "" },
        { id: 20, label: "Account Holder Name", key: "account_holder_name", value: verficationList?.account_holder_name, isError: !!storedRemarks[20], action: false, remark: storedRemarks[20] || "" },
        { id: 21, label: "Bank Account Number", key: "bank_account_number", value: verficationList?.bank_account_number, isError: !!storedRemarks[21], action: false, remark: storedRemarks[21] || "" },
        { id: 22, label: "IFSC Code", key: "ifsc_code", value: verficationList?.ifsc_code, isError: !!storedRemarks[22], action: false, remark: storedRemarks[22] || "" },
        { id: 23, label: "Branch Name", key: "branch_name", value: verficationList?.branch_name, isError: !!storedRemarks[23], action: false, remark: storedRemarks[23] || "" },
        { id: 24, label: "Education Level", key: "education_level", value: verficationList?.education_level, isError: !!storedRemarks[24], action: false, remark: storedRemarks[24] || "" },
        { id: 25, label: "Marital Status", key: "maritial_status", value: verficationList?.maritial_status, isError: !!storedRemarks[25], action: false, remark: storedRemarks[25] || "" },
        { id: 26, label: "Highest Achievement", key: "highest_achievement", value: verficationList?.highest_achievement, isError: !!storedRemarks[26], action: false, remark: storedRemarks[26] || "" },
        { id: 27, label: "Identity Card", key: "identity_card", value: verficationList?.identity_card, isError: !!storedRemarks[27], action: false, remark: storedRemarks[27] || "" },
        { id: 28, label: "Identity Type", key: "identity_type", value: verficationList?.identity_type, isError: !!storedRemarks[28], action: false, remark: storedRemarks[28] || "" },
        { id: 29, label: "Mother Name", key: "mother_name", value: verficationList?.mother_name, isError: !!storedRemarks[29], action: false, remark: storedRemarks[29] || "" },
      ];
      
      if (
        verficationList.registration_docs &&
        Array.isArray(verficationList.registration_docs)
      ) {
        verficationList.registration_docs.forEach((doc, index) => {
          const displayLabel =
            doc.doc_name === "other" ? "Last Year Marksheet" : doc.doc_name;
          baseList.push({
            id: 29 + index, // Assuming the IDs continue sequentially
            label: displayLabel,
            value: doc.doc_file, // Assuming you want to display the file or use doc_name
            key: `registration_doc_${index + 1}`,
            action: false,
            remark: storedRemarks[29 + index] || "",
            isError: !!storedRemarks[29 + index],
          });
        });
      }

      setInsituteVerifyList(baseList);
    }
  };

  useEffect(() => {
    fetchCountryName();
  }, [verficationList]);

  const handleRadioChange = (id) => {
    setCurrentRemarkId(id);
    setRemarkshowModal(true);
   
  };

  const handleRadiogreenChange = (id) => {
    const storedIndividualRemarks =
      JSON.parse(localStorage.getItem("remarksIndividual")) || {};
    delete storedIndividualRemarks[id];
    localStorage.setItem(
      "remarksIndividual",
      JSON.stringify(storedIndividualRemarks)
    );
    fetchCountryName();
    setCurrentRemarkId(id);

    const isEmpty = Object.keys(storedIndividualRemarks).length === 0;
    if (isEmpty) {
      setshowremarkCard(true);
    }
    insituteVerifyList.map((data) => {
      if (id === data.id) {
        data.isError = false;
      }
    });
  };

  const updateRemark = (remark) => {
    const updatedList = insituteVerifyList.map((item) => {
      if (item.id === currentRemarkId) {
        return { ...item, remark };
      }
      return item;
    });

    setInsituteVerifyList(updatedList);
    const storedIndividualRemarks =
      JSON.parse(localStorage.getItem(`remarksIndividual`)) || {};
    storedIndividualRemarks[currentRemarkId] = remark;
    localStorage.setItem(
      `remarksIndividual`,
      JSON.stringify(storedIndividualRemarks)
    );
  };

  useEffect(() => {
    const storedIndividualRemarks =
      JSON.parse(localStorage.getItem("remarksIndividual")) || {};
    const isEmpty = Object.keys(storedIndividualRemarks).length === 0;
    if (isEmpty) {
      setshowremarkCard(true);
    } else {
      setshowremarkCard(false);
    }
  }, [insituteVerifyList]);

  const profileImage = insituteVerifyList.find(
    (item) => item.label === "profile_image"
  );
 
  const getCorrectionList = async (roletype, id) => {
    try {
      const response = await getCorrectionByID(roletype, id);
      const correctionData = response?.data?.data;

      if (correctionData && correctionData.registration_correction) {
        const storedRemarks =
          JSON.parse(localStorage.getItem("remarksIndividual")) || {};
        // console.log("storedRemarks",storedRemarks);
        correctionData.registration_correction.forEach((correction, index) => {
          if (correction.remark) {
            storedRemarks[correction.id] = correction.remark;
          }
        });

        localStorage.setItem(
          "remarksIndividual",
          JSON.stringify(storedRemarks)
        );
        setInsituteVerifyList((prevList) =>
          prevList.map((item) =>
            item.id === id ? { ...item, remarks: storedRemarks } : item
          )
        );
      }

      setCorrectionData(correctionData);
    } catch (error) {
      console.error("Error fetching verification list:", error);
    }
  };

  useEffect(() => {
    getCorrectionList(roletype, id);
  }, [id]);

  return (
    <>
      <IndividualDetails verficationList={verficationList} />
      <div className="row">
        <Col lg={12} className="mb-3">
          <Card style={{ height: "35vh" }}>
            <Card.Header>
              <Card.Title className="text-danger">VERIFY PHOTO</Card.Title>
            </Card.Header>
            <Card.Body>
              <Table responsive>
                <thead>
                  <tr>
                    <th>SN</th>
                    <th> Profile Photo</th>
                    <th>Action</th>
                    <th style={{width:"350px"}}>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>1</th>

                    <td>
                      {profileImage?.value ? (
                        <img
                          src={profileImage?.value}
                          alt="Profile"
                          style={{ width: "40px", height: "40px" }}
                        />
                      ) : (
                        "Photo not available"
                      )}
                      <a
                        href={profileImage?.value}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text_view mx-1"
                      >
                        View file
                      </a>
                    </td>
                    <td>
                      <div className="d-flex">
                        <div className="form-check">
                          <input
                            className="form-check-input bg-success"
                            type="radio"
                            name={`gridRadios-${profileImage?.id}`}
                            value="option1"
                            checked={!profileImage?.isError}
                            onChange={() =>
                              handleRadiogreenChange(profileImage?.id)
                            }
                          />
                        </div>
                        <div className="form-check mx-2">
                          <input
                            className="form-check-input bg-danger"
                            type="radio"
                            name={`gridRadios-${profileImage?.id}`}
                            value="option1"
                            checked={profileImage?.isError}
                            onClick={(event) =>
                              handleRadioChange(profileImage?.id)
                            }
                          />

                        </div>
                      </div>
                    </td>
                    <td className="remarks-column">{profileImage?.remark}</td>
                  </tr>
                </tbody>
              </Table>
            </Card.Body>
          </Card>

          <Card className="mb-3" style={{ height: "auto" }}>
            <Card.Header>
              <Card.Title className="text-danger">
                VERIFY FORM FIELDS & DOCUMENTS
              </Card.Title>
            </Card.Header>
            <Card.Body>
              <Table responsive>
                <thead>
                  <tr>
                    <th>SN</th>
                    <th>Form Fields</th>
                    <th>Action</th>
                    <th style={{width:"200px"}}>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {insituteVerifyList
                    .filter((data) => data.value)
                    .map((data, index) => {
                      return (
                        <>
                          {" "}
                          {data.label === "profile_image" ? (
                            " "
                          ) : (
                            <tr key={data.id}>
                              <td>{index + 1}</td>
                              <td>
                                <span style={{ color: "#886CC0" }}>
                                  <strong>{formatLable(data?.label)}</strong>
                                </span>
                                <br />
                                {isValidUrl(data.value) ? (
                                  <div>
                                    {data.value.includes(".pdf") ? (
                                      <img
                                        src={imgPdf}
                                        alt={data.label}
                                        style={{
                                          maxWidth: "100px",
                                          height: "auto",
                                        }}
                                      />
                                    ) : data.value.includes(".doc") ? (
                                      <img
                                        src={doc}
                                        alt={data.label}
                                        style={{
                                          maxWidth: "100px",
                                          height: "auto",
                                        }}
                                      />
                                    ) : (
                                      <img
                                        src={data.value}
                                        alt={data.label}
                                        style={{
                                          maxWidth: "100px",
                                          height: "auto",
                                        }}
                                      />
                                    )}
                                    <a
                                      href={data.value}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="text_view mx-1"
                                    >
                                      View file
                                    </a>
                                  </div>
                                ) : (
                                  <span style={{ fontSize: "13px" }}>
                                    {data.value}
                                  </span>
                                )}
                              </td>

                              <td>
                                <div className="d-flex">
                                  <div className="form-check">
                                    <input
                                      className="form-check-input bg-success"
                                      type="radio"
                                      name={`gridRadios-${data.id}`}
                                      value="option1"
                                      checked={!data.isError}
                                      onChange={() =>
                                        handleRadiogreenChange(data?.id)
                                      }
                                    />
                                  </div>
                                  <div className="form-check mx-2">
                                    <input
                                      className="form-check-input bg-danger"
                                      type="radio"
                                      name={`gridRadios-${data.id}`}
                                      value="option1"
                                      checked={data.isError}
                                      onClick={(event) =>
                                        handleRadioChange(data?.id)
                                      }
                                    />
                                  </div>
                                </div>
                              </td>
                              <td className="remarks-column">{data.remark}</td>
                            </tr>
                          )}
                        </>
                      );
                    })}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </div>
      <RemarkModal
        remarkshowModal={remarkshowModal}
        setRemarkshowModal={setRemarkshowModal}
        setRemarkdata={setRemarkdata}
        setVerficationList={setVerficationList}
        remarkdata={remarkdata}
        currentRemarkId={currentRemarkId}
        updateRemark={updateRemark}
        setshowremarkCard={setshowremarkCard}
        insituteVerifyList={insituteVerifyList}
      />

      {verficationList?.status === "final_submit" ? (
        showremarkrCard ? (
          <CleardCard id="1" clerVerifyApi={clearIndividualVerfication} />
        ) : (
          <NotCleardCard insituteVerifyList={insituteVerifyList} id="1" />
        )
      ) : verficationList?.status === "ongoing" ? (
        <Card className="text-center p-3">
          <h3 className="text-danger">
            It seems that Individual has not started further registration
            Process!
          </h3>
        </Card>
      ) : verficationList?.status === "ask_for_resubmit" ? (
        <Card className="text-center p-3">
          <h4>
            <span className="text-danger">Note: </span>
            The Application is sent back to the User for corrections. Once the
            User corrects information's asked, we can do further verification.
          </h4>
        </Card>
      ) : (
        ""
      )}
    </>
  );
};

export default IndividualVerificationForm;
